export default {
  title: 'Denne restaurant kan ikke gå live endnu',
  description:
    'Din partnerkonto har intet behandlingsgebyr for onlinebetalinger og har ikke bekræftet 0 % margin. Stripe opkræver sine gebyrer hos din platform, så et af de to skal besluttes først.',
  partner_action:
    'Fastsæt et standardbehandlingsgebyr, eller bekræft, at du ikke opkræver nogen af dine restauranter og selv betaler Stripes gebyrer.',
  ask_partner:
    'Din partner har endnu ikke fastsat sit gebyr for onlinebetalinger. Denne restaurant kan gå live, så snart det er gjort.',
  buttons: {
    set_rate: 'Fastsæt behandlingsgebyr',
    close: 'Luk',
  },
};
